import { Box, Container, Stack, Typography } from '@mui/material';
import { colors, pagePadding } from './landingTheme';
import { features } from './landingData';
import LinkButton from './LinkButton';

const FeaturesSection = ({ onLogin }) => (
    <Box id="features" component="section" sx={{ bgcolor: '#020617', py: { xs: 2, md: 3 } }}>
        <Container maxWidth={false} sx={pagePadding}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                    gap: { xs: 2, md: 3 },
                }}
            >
                {features.map((feature, index) => (
                    <Box
                        id={feature.id}
                        key={feature.title}
                        sx={{
                            minHeight: { xs: 360, md: 500 },
                            borderRadius: 0,
                            p: { xs: 3, md: 5 },
                            textAlign: 'center',
                            bgcolor: colors.panel,
                            color: 'text.primary',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: 64,
                                height: 64,
                                borderRadius: 999,
                                display: 'grid',
                                placeItems: 'center',
                                color: '#fff',
                                bgcolor: feature.tone,
                                mb: 2,
                            }}
                        >
                            {feature.icon}
                        </Box>
                        <Typography variant="h2" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
                            {feature.title}
                        </Typography>
                        <Typography
                            sx={{
                                mt: 1.5,
                                maxWidth: 430,
                                color: 'text.secondary',
                                fontSize: { xs: '1rem', md: '1.12rem' },
                                lineHeight: 1.6,
                            }}
                        >
                            {feature.text}
                        </Typography>
                        {index === 0 && (
                            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                                <LinkButton onClick={onLogin}>Jetzt anmelden</LinkButton>
                            </Stack>
                        )}
                    </Box>
                ))}
            </Box>
        </Container>
    </Box>
);

export default FeaturesSection;
